<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        [defaultHref]="isOnboardingFlow ? '/onboarding/login' : '/more/login-credentials'"
      ></ion-back-button>
    </ion-buttons>
    <ion-title>Change Password</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onSubmit()" [disabled]="form.invalid">
        Save<ion-icon slot="end" name="checkmark-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</red-header-content>

<red-page-content>
  @if (isPasswordExpired) {
  <div class="tw:m-4 tw:text-xs">
    <ion-note color="medium">It seems that your password has expired. You will need to change it and retry.</ion-note>
  </div>
  }
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item-divider color="primary">
        <ion-label>{{dataPortalName$ | async}} Password</ion-label>
      </ion-item-divider>
      <ion-item>
        <ion-input
          redErrorMessage
          type="password"
          labelPlacement="stacked"
          inputmode="text"
          [required]="true"
          formControlName="oldPassword"
        >
          <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          <div slot="label">Old Password:<ion-text color="danger">*</ion-text></div></ion-input
        >
      </ion-item>
      <ion-item>
        <ion-input
          redErrorMessage
          type="password"
          labelPlacement="stacked"
          inputmode="text"
          [required]="true"
          formControlName="password"
        >
          <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          <div slot="label">New Password:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          redErrorMessage
          type="password"
          labelPlacement="stacked"
          inputmode="text"
          [required]="true"
          formControlName="confirmPassword"
        >
          <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          <div slot="label">Confirm Password:<ion-text color="danger">*</ion-text></div></ion-input
        >
      </ion-item>
    </ion-list>
  </form>
</red-page-content>
